

// import React, { useState, useEffect  } from 'react';
// import { useNavigate } from 'react-router-dom';

// import {
//   Box,
//   Button,
//   Typography,
//   Paper,
//   Grid,
//   RadioGroup,
//   Radio,
//   FormControlLabel,
//   FormControl,
//   FormLabel,
//   CircularProgress,
//   TextField,
//   Select,
//   MenuItem,
//   InputLabel,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import Swal from 'sweetalert2';
// import Confetti from 'react-confetti';

// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../landpageimage1/DYPLogo.png';

// const themeColors = {
//   primary: '#2196F3',
//   gradient: 'linear-gradient(135deg, #2196F3 0%, #6633EE 100%)',
//   background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
// };

// const StyledPaper = styled(Paper)(() => ({
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   width: '90%',
//   maxWidth: '800px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   padding: '24px',
//   backgroundColor: '#FFFFFF',
//   boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
// }));

// const StyledButton = styled(Button)(() => ({
//   background: themeColors.gradient,
//   color: 'white',
//   padding: '8px 16px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     background: '#1E88E5',
//   },
// }));

// const LogoContainer = styled(Box)(() => ({
//   display: 'grid',
//   gridTemplateColumns: 'repeat(4, 1fr)',
//   gap: '16px',
//   justifyContent: 'center',
//   alignItems: 'center',
//   width: '100%',
//   padding: '16px 0',
//   marginBottom: '16px',
//   '@media (max-width: 600px)': {
//     gridTemplateColumns: 'repeat(2, 1fr)',
//   },
// }));

// const LogoImage = styled('img')(() => ({
//   maxWidth: '100px',
//   maxHeight: '80px',
//   objectFit: 'contain',
//   margin: '0 auto',
// }));

// export default function FeedbackForm() {
//   const [feedback, setFeedback] = useState({
//     initialReaction: '',
//     recommendLikelihood: '',
//     projectChange: '',
//     scalability: '',
//     problemAddressed: '',
//     innovativeness: '',
//     additionalComments: '',
//     name: '',
//     email: '',
//     contactNumber: '',
//   });
//   const [loading, setLoading] = useState(false);
//   const [showConfetti, setShowConfetti] = useState(true);
//   const [projectDetails, setProjectDetails] = useState({
//     title: '',
//     description: '',
//     id: '',
//   });
//   const [errors, setErrors] = useState({
//     name: '',
//     email: '',
//     contactNumber: '',
//   });

//   // Fetch project details from URL parameters
//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const title = urlParams.get('title') || '';
//     const description = urlParams.get('description') || '';
//     const id = urlParams.get('id') || '';

//     setProjectDetails({ title, description, id });

//     // Set confetti timeout for 2 seconds
//     setTimeout(() => setShowConfetti(false), 6000);
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFeedback((prevFeedback) => ({
//       ...prevFeedback,
//       [name]: value,
//     }));
//   };
//   const validateFields = () => {
//     const { name, email, contactNumber } = feedback;
//     const newErrors = {};

//     // Name validation
//     if (!name.trim()) {
//       newErrors.name = 'Name is required.';
//     }

//     // Email validation
//     const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//     if (!emailPattern.test(email)) {
//       newErrors.email = 'Enter a valid email address.';
//     }

//     // Contact number validation (simple number validation)
//     const contactPattern = /^\d{10}$/;
//     if (!contactPattern.test(contactNumber)) {
//       newErrors.contactNumber = 'Enter a valid 10-digit contact number.';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setShowConfetti(true);
  
//     // Get the id from URL params
//     const urlParams = new URLSearchParams(window.location.search);
//     const projectId = urlParams.get('id');
  
//     try {
//       // Use template literals correctly for the API URL
//       const response = await fetch(`https://newbackend.elephant-tank.com/api/feedback/${projectId}/`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           ...feedback,
//           projectId: projectId, // Add the id to the payload
//         }),
//       });
  
//       if (response.ok) {
//         Swal.fire('Thank You!', 'Your feedback has been submitted successfully.', 'success');
//         // Show confetti for 5 seconds
//         setTimeout(() => {
//           setShowConfetti(false);
//           navigate('/'); // Navigate to home after confetti
//         }, 5000);
//       } else {
//         const errorData = await response.json();
//         Swal.fire('Error', errorData.message || 'Failed to submit feedback.', 'error');
//       }
//     } catch (error) {
//       Swal.fire('Error', 'An unexpected error occurred. Please try again.', 'error');
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//         padding: '16px',
//         flexDirection: 'column',
//       }}
//     >
//       {showConfetti && <Confetti />}
//       <LogoContainer>
//         <LogoImage src={Logo1} alt="Logo 1" />
//         <LogoImage src={Logo2} alt="Logo 2" />
//         <LogoImage src={Logo3} alt="Logo 3" />
//         <LogoImage src={Logo4} alt="Logo 4" />
//       </LogoContainer>
//       <StyledPaper>
        
//       <Typography
//   variant="body1"
//   color="textSecondary"
//   textAlign="center"
//   paragraph
//   sx={{ color: '#2196F3', fontWeight: 'bold' }} // Making the text bold
// >
//   Idea Name : {projectDetails.title}
// </Typography>

// <Typography
//   variant="body2"
//   color="textSecondary"
//   textAlign="center"
//   paragraph
//   sx={{ color: '#6633EE', fontWeight: 'bold' }} // Making the text bold
// >
//   Idea Description: {projectDetails.description}
// </Typography>


//         <Typography variant="h5" fontWeight="bold" color="primary" textAlign="center">
//           Project Feedback Form
//         </Typography>
//         <form onSubmit={handleSubmit} style={{ width: '100%' }}>
//           <Grid container spacing={3}>
//             <Grid item xs={12}>
//               <TextField
//                 label="Full Name"
//                 fullWidth
//                 name="name"
//                 value={feedback.name}
//                 onChange={handleChange}
//                 error={!!errors.name}
//                 helperText={errors.name}
//                 required
//               />
//             </Grid>

//             {/* Email Field */}
//             <Grid item xs={12}>
//               <TextField
//                 label="Email"
//                 fullWidth
//                 name="email"
//                 value={feedback.email}
//                 onChange={handleChange}
//                 error={!!errors.email}
//                 helperText={errors.email}
//                 required
//               />
//             </Grid>

//             {/* Contact Number Field */}
//             <Grid item xs={12}>
//               <TextField
//                 label="Contact Number"
//                 fullWidth
//                 name="contactNumber"
//                 value={feedback.contactNumber}
//                 onChange={handleChange}
//                 error={!!errors.contactNumber}
//                 helperText={errors.contactNumber}
//                 required
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <FormControl fullWidth>
//                 <FormLabel>What is your initial reaction to the project idea?</FormLabel>
//                 <RadioGroup
//                   name="initialReaction"
//                   value={feedback.initialReaction}
//                   onChange={handleChange}
//                   row
//                 >
//                   {['Excited', 'Neutral', 'Disappointed', 'Confused', 'Indifferent'].map((reaction) => (
//                     <FormControlLabel
//                       key={reaction}
//                       value={reaction}
//                       control={<Radio color="primary" />}
//                       label={reaction}
//                     />
//                   ))}
//                 </RadioGroup>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12}>
//               <FormControl fullWidth>
//                 <FormLabel>How likely are you to recommend this project to others?</FormLabel>
//                 <RadioGroup
//                   name="recommendLikelihood"
//                   value={feedback.recommendLikelihood}
//                   onChange={handleChange}
//                   row
//                 >
//                   {[1, 2, 3, 4, 5].map((rating) => (
//                     <FormControlLabel
//                       key={rating}
//                       value={String(rating)}
//                       control={<Radio color="primary" />}
//                       label={rating}
//                     />
//                   ))}
//                 </RadioGroup>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12}>
//               <FormControl fullWidth>
//                 <FormLabel>If you could change one thing about the project, what would it be?</FormLabel>
//                 <Select
//                   name="projectChange"
//                   value={feedback.projectChange}
//                   onChange={handleChange}
//                   required
//                 >
//                   <MenuItem value="More features/functionalities">More features/functionalities</MenuItem>
//                   <MenuItem value="Improved user interface/experience">Improved user interface/experience</MenuItem>
//                   <MenuItem value="Better scalability">Better scalability</MenuItem>
//                   <MenuItem value="More focused target audience">More focused target audience</MenuItem>
//                   <MenuItem value="More market research/data">More market research/data</MenuItem>
//                   <MenuItem value="No changes needed">No changes needed</MenuItem>
//                   <MenuItem value="Other">Other (please specify)</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>

//             {/* Conditionally render text area for "Other" option */}
//             {feedback.projectChange === 'Other' && (
//               <Grid item xs={12}>
//                 <TextField
//                   label="Please specify your changes"
//                   multiline
//                   fullWidth
//                   rows={4}
//                   name="projectChangeDetails"
//                   value={feedback.projectChangeDetails}
//                   onChange={handleChange}
//                   variant="outlined"
//                 />
//               </Grid>
//             )}

//             <Grid item xs={12}>
//               <FormControl fullWidth>
//                 <FormLabel>Do you think the project idea will be scalable or sustainable in the long term?</FormLabel>
//                 <RadioGroup
//                   name="scalability"
//                   value={feedback.scalability}
//                   onChange={handleChange}
//                   row
//                 >
//                   {['Yes, very scalable', 'Somewhat scalable', 'Not sure', 'Not scalable', 'No, not sustainable'].map((option) => (
//                     <FormControlLabel
//                       key={option}
//                       value={option}
//                       control={<Radio color="primary" />}
//                       label={option}
//                     />
//                   ))}
//                 </RadioGroup>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12}>
//               <FormControl fullWidth>
//                 <FormLabel>How well do you think this project addresses the problem it aims to solve?</FormLabel>
//                 <RadioGroup
//                   name="problemAddressed"
//                   value={feedback.problemAddressed}
//                   onChange={handleChange}
//                   row
//                 >
//                   {['Very well', 'Well', 'Neutral', 'Poorly', 'Not at all'].map((option) => (
//                     <FormControlLabel
//                       key={option}
//                       value={option}
//                       control={<Radio color="primary" />}
//                       label={option}
//                     />
//                   ))}
//                 </RadioGroup>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12}>
//               <FormControl fullWidth>
//                 <FormLabel>How innovative or unique do you find this project idea?</FormLabel>
//                 <RadioGroup
//                   name="innovativeness"
//                   value={feedback.innovativeness}
//                   onChange={handleChange}
//                   row
//                 >
//                   {['Very innovative', 'Innovative', 'Neutral', 'Not very innovative', 'Not innovative at all'].map((option) => (
//                     <FormControlLabel
//                       key={option}
//                       value={option}
//                       control={<Radio color="primary" />}
//                       label={option}
//                     />
//                   ))}
//                 </RadioGroup>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//   <TextField
//     label="Anything more about this idea/project?"
//     multiline
//     fullWidth
//     rows={4}
//     name="additionalComments"
//     value={feedback.additionalComments}
//     onChange={(e) => {
//       const words = e.target.value.split(/\s+/);
//       if (words.length <= 30) {
//         setFeedback((prevFeedback) => ({
//           ...prevFeedback,
//           additionalComments: e.target.value,
//         }));
//       }
//     }}
//     variant="outlined"
//     helperText={`${feedback.additionalComments.split(/\s+/).length}/30 words`}
//   />
// </Grid>


//             <Grid item xs={12}>
//               <StyledButton type="submit" fullWidth disabled={loading}>
//                 {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit Feedback'}
//               </StyledButton>
//             </Grid>
//           </Grid>
//         </form>
//       </StyledPaper>
//     </Box>
//   );
// }
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Typography,
  Paper,
  Grid,
  CircularProgress,
  TextField,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Swal from 'sweetalert2';
import Confetti from 'react-confetti';

const themeColors = {
  primary: '#2196F3',
  gradient: 'linear-gradient(135deg, #2196F3 0%, #6633EE 100%)',
  background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
};

const StyledPaper = styled(Paper)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '90%',
  maxWidth: '800px',
  margin: '0 auto',
  borderRadius: '24px',
  padding: '24px',
  backgroundColor: '#FFFFFF',
  boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
}));

const StyledButton = styled(Button)(() => ({
  background: themeColors.gradient,
  color: 'white',
  padding: '8px 16px',
  borderRadius: '16px',
  fontWeight: 600,
  '&:hover': {
    background: '#1E88E5',
  },
}));

export default function FeedbackForm() {
  const [feedback, setFeedback] = useState({
    email: '',
    presentation_rating: '',
    overall_score: '',
  });
  const [loading, setLoading] = useState(false);
  const [showConfetti, setShowConfetti] = useState(true);
  const [projectDetails, setProjectDetails] = useState({
    title: '',
    id: '',
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const title = urlParams.get('title') || '';
    const id = urlParams.get('id') || '';

    setProjectDetails({ title, id });
    setTimeout(() => setShowConfetti(false), 6000);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFeedback((prevFeedback) => ({
      ...prevFeedback,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`https://newbackend.elephant-tank.com/api/feedback/${projectDetails.id}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          idea: projectDetails.id,
          ...feedback,
        }),
      });

      
      if (response.ok) {
        Swal.fire('Thank You!', 'Your feedback has been submitted successfully.', 'success');
        setTimeout(() => {
          setShowConfetti(false);
          navigate('/');
        }, 5000);
      } else {
        const errorData = await response.json();
        Swal.fire('Error', errorData.message || 'Failed to submit feedback.', 'error');
      }
    } catch (error) {
      Swal.fire('Error', 'An unexpected error occurred. Please try again.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: themeColors.background,
        padding: '16px',
        flexDirection: 'column',
      }}
    >
      {showConfetti && <Confetti />}
      <StyledPaper>
        <Typography
          variant="h5"
          fontWeight="bold"
          color="primary"
          textAlign="center"
        >
          Feedback for {projectDetails.title}
        </Typography>
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                label="Email"
                fullWidth
                name="email"
                value={feedback.email}
                onChange={handleChange}
                required
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Presentation Rating (1-10)"
                fullWidth
                name="presentation_rating"
                type="number"
                value={feedback.presentation_rating}
                onChange={handleChange}
                inputProps={{ min: 1, max: 10 }}
                required
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Overall Score (1-100)"
                fullWidth
                name="overall_score"
                type="number"
                value={feedback.overall_score}
                onChange={handleChange}
                inputProps={{ min: 1, max: 100 }}
                required
              />
            </Grid>

            <Grid item xs={12}>
              <StyledButton type="submit" fullWidth disabled={loading}>
                {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit Feedback'}
              </StyledButton>
            </Grid>
          </Grid>
        </form>
      </StyledPaper>
    </Box>
  );
}

